// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

/**
 * @deprecated use "@tock/icons" import instead
 * This new package will be where all Icons are imported from going forward
 * You can still use these icons in <IconMigrationUtil /> as the legacy icon
 */
export const SvgIconEvents = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: '1em', height: '1em', viewBox: '0 0 24 24', fill: 'none', ...props },
    <path
      d="M23.714 7.146a1.506 1.506 0 00-.17-1.962L18.818.455a1.505 1.505 0 00-1.962-.169 3.393 3.393 0 01-3.924 0 1.507 1.507 0 00-1.961.17L.455 10.971a1.54 1.54 0 00-.169 1.962 3.394 3.394 0 010 3.924 1.506 1.506 0 00.17 1.962l4.727 4.728a1.523 1.523 0 001.962.17 3.393 3.393 0 013.924 0c.268.197.578.282.889.282.395 0 .776-.155 1.072-.452l10.515-10.516a1.524 1.524 0 00.169-1.962 3.394 3.394 0 010-3.924zm-1.157 4.884L12.042 22.546a.109.109 0 01-.14.014 4.788 4.788 0 00-5.561 0c-.043.028-.113.029-.142-.014l-4.727-4.729a.109.109 0 01-.015-.14 4.793 4.793 0 000-5.562.109.109 0 01.015-.141L11.986 1.458a.109.109 0 01.141-.014 4.79 4.79 0 005.56 0 .109.109 0 01.142.014l4.728 4.728a.109.109 0 01.014.141 4.793 4.793 0 000 5.562c.028.042.014.099-.014.141z"
      fill="currentColor"
    />,
    <path
      d="M14.032 4.916c-.79-.79-2.088-.79-2.893 0l-6.21 6.21a2.041 2.041 0 00-.592 1.44c0 .551.211 1.06.592 1.44l5.053 5.054a2.03 2.03 0 001.44.592 2.03 2.03 0 001.439-.592l6.21-6.211a2.04 2.04 0 00.592-1.44c0-.55-.211-1.059-.592-1.44l-5.039-5.053zm4.05 6.945l-6.209 6.21c-.24.24-.65.24-.89 0l-5.052-5.053a.653.653 0 01-.183-.452c0-.169.07-.324.183-.451l6.21-6.211a.618.618 0 01.452-.183c.17 0 .324.056.451.183l5.053 5.053a.653.653 0 01.183.452c-.014.183-.07.339-.197.452z"
      fill="currentColor"
    />,
    <path
      d="M13.087 8.6a.699.699 0 00-1.002 0l-3.472 3.473a.699.699 0 000 1.002.709.709 0 00.494.211c.17 0 .367-.07.494-.211l3.472-3.473a.687.687 0 00.014-1.002zM13.298 12.03l-1.086 1.087a.699.699 0 000 1.002.71.71 0 00.494.212c.17 0 .367-.07.494-.212l1.086-1.087a.699.699 0 000-1.002.682.682 0 00-.988 0z"
      fill="currentColor"
    />
  );
export default SvgIconEvents;
